import type { Column, SelectOption } from "@clintonelec/react-storybook";
import { EapType, ENCRYPTIONS, HttpAuthenticationType, IpFilterRule, RtspAuthenticationType } from "Interfaces";

export const ipFilterRuleOptions: SelectOption[] = [
	{
		label: "Allow List",
		value: IpFilterRule.ALLOW
	},
	{
		label: "Block List",
		value: IpFilterRule.BLOCK
	}
];

export const ipFilterTableColumns: Column[] = [
	{
		key: "ipAddress",
		title: "IP Address",
		dataIndex: "ipAddress"
	},
	{
		key: "action",
		title: "Action",
		dataIndex: "action",
		sortable: false
	}
];

export const encryptionTypeOptions: SelectOption[] = ENCRYPTIONS.map(encryption => ({
	label: encryption,
	value: encryption
}));

export const rtspOptions: SelectOption[] = [
	{
		label: "Off",
		value: RtspAuthenticationType.OFF
	},
	{
		label: "Basic",
		value: RtspAuthenticationType.BASIC
	},
	{
		label: "Digest",
		value: RtspAuthenticationType.DIGEST
	}
];

export const httpsAuthTypeOptions: SelectOption[] = [
	{
		label: "Basic",
		value: HttpAuthenticationType.BASIC
	},
	{
		label: "Digest",
		value: HttpAuthenticationType.DIGEST
	}
];

export const eapTypeOptions: SelectOption[] = [
	{
		label: "EAP-TLS",
		value: EapType.TLS
	},
	{
		label: "EAP-MD5",
		value: EapType.MD5
	}
];

export const eapolOptions: SelectOption[] =
	[ 1, 2, 3, 4 ].map(current => ({ label: `${ current }`, value: current }));
